import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

function ValidationReportDialog({
  validationDialogOpen,
  setValidationDialogOpen,
  validationErrors,
  handleDownloadReport,
}) {
  return (
    <Dialog
      open={validationDialogOpen}
      onClose={() => setValidationDialogOpen(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Course Validation Failed</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Found {validationErrors.length} issue(s) that must be fixed before
          publishing:
        </DialogContentText>
        <DialogContentText
          component="div"
          sx={{
            maxHeight: "400px",
            overflow: "auto",
            backgroundColor: "#f5f5f5",
            padding: 2,
            borderRadius: 1,
            fontFamily: "monospace",
            fontSize: "0.875rem",
            whiteSpace: "pre-wrap",
          }}
        >
          {validationErrors.map((err, idx) => (
            <div key={idx}>- {err}</div>
          ))}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setValidationDialogOpen(false)} color="error">
          Close
        </Button>
        <Button onClick={handleDownloadReport} variant="contained">
          Download Full Report
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ValidationReportDialog;
